import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../../css/dashboard.css";
import axios from 'axios';
import dayjs from 'dayjs';
import Pagination from "react-js-pagination";
import styled from "styled-components";
import DaumPostcode from 'react-daum-postcode';

import CommonTable from "../component/table_list/common_table";
import CommonTableRow from "../component/table_list/common_tablerow";
import CommonTableColumn from "../component/table_list/common_tablecolumn";
import { useAuthContext } from '../common/ProtectedLayout';
import { formatWon } from '../utils/format_amount';

function NoticeList(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const auth = useAuthContext();

    const [reserveList, setReserveList] = useState([]);
    const [reserveCount, setReserveCount] = useState(0);
    const [page, setPage] = useState(1);
    const [statusFilter, setStatusFilter] = useState('전체'); // 상태 필터
    const [view, setView] = useState(false); // 드롭다운 표시 상태
    const items = 10;

    const hadlePageChange = (page) => {
        setPage(page);
    };

    const getReservationTotal = async () => {
        try {
            const pageIndex = page - 1;
            const result = await axios.get(`/NoticeList/${pageIndex}`, {
                params: { status: statusFilter }
            });
            setReserveList(result.data.message);
        } catch (error) {
            console.error('Error fetching notice list:', error.message);
        }
    };

    const getReserveCount = async () => {
        try {
            const result = await axios.get('/NoticeList/Count/All', {
                params: { status: statusFilter }
            });
            setReserveCount(result.data.message);
        } catch (error) {
            console.error('Error fetching count:', error.message);
        }
    }

    const handleNoticeClick = async (idx) => {
        if (!window.confirm('공고를 게시하시겠습니까?')) return;

        try {
            const res = await axios.put(`/NoticeList/Status/${idx}`, { status: '공고' });
            if (res.data.success) {
                alert('공고가 게시되었습니다.');
                getReservationTotal();
            } else {
                alert('공고 게시에 실패했습니다.');
            }
        } catch (error) {
            console.error('Error updating notice status:', error);
            alert('오류가 발생했습니다.');
        }
    };

    const handleDeleteClick = async (idx, status) => {
        const confirmMessage = status === '대기'
            ? '이 공고를 삭제하시겠습니까?'
            : '⚠️ 주의: 이미 공고가 진행된 건입니다.\n\n삭제 시 관련 매칭 정보 및 기사 배정에 문제가 발생할 수 있습니다.\n\n정말 삭제하시겠습니까?';
        if (!window.confirm(confirmMessage)) return;

        try {
            const res = await axios.delete(`/NoticeList/${idx}`);
            if (res.data.success) {
                alert('삭제되었습니다.');
                getReservationTotal();
                getReserveCount();
            } else {
                alert('삭제에 실패했습니다.');
            }
        } catch (error) {
            console.error('Error deleting notice:', error);
            alert(error.response?.data?.message || '오류가 발생했습니다.');
        }
    };

    // Modal & Form State
    const modalNotice = useRef();
    const addressModalRef = useRef();
    const [addressModalOpen, setAddressModalOpen] = useState(false);
    const [productList, setProductList] = useState([]);

    // Address Modal Control
    useEffect(() => {
        if (addressModalOpen) {
            addressModalRef.current?.showModal();
        } else {
            addressModalRef.current?.close();
        }
    }, [addressModalOpen]);

    // Notice Info State
    const [noticeInfo, setNoticeInfo] = useState({
        req_number: '',
        work_date: '',
        work_time: '',
        address: '',
        address_sub: '',
        info: '', // Will be comma-separated string
        option: '',
        working_kind: '',
        amount: '',
        memo: '',
        admin_memo: ''
    });

    const startNoticeModal = async () => {
        // Reset form - 오더번호는 작업일 입력 시 자동 생성
        setNoticeInfo({
            req_number: '', work_date: '', work_time: '', address: '', address_sub: '', info: '', option: '', working_kind: '', amount: '', memo: '', admin_memo: ''
        });
        setSelectedProducts([]);
        modalNotice.current.showModal();
    }

    // 복사 버튼 클릭 핸들러 - 기존 공고 정보로 모달 열기
    const handleCopyClick = async (reserve) => {
        // Parse info string to selectedProducts
        const parsedProducts = [];
        if (reserve.info) {
            const items = reserve.info.split(',').map(item => item.trim());
            items.forEach(item => {
                const lastSpaceIndex = item.lastIndexOf(' ');
                let name = item;
                let count = 1;

                if (lastSpaceIndex > -1) {
                    name = item.substring(0, lastSpaceIndex);
                    const countStr = item.substring(lastSpaceIndex + 1);
                    const countMatch = countStr.match(/\d+/);
                    if (countMatch) {
                        count = parseInt(countMatch[0], 10);
                    }
                }
                parsedProducts.push({ name, count });
            });
        }

        // 새 오더번호 생성 (작업일 기준)
        let newReqNumber = '';
        if (reserve.work_date) {
            try {
                const res = await axios.get('/GenerateOrderNumber', {
                    params: { work_date: reserve.work_date }
                });
                if (res.data.success) {
                    newReqNumber = res.data.message;
                }
            } catch (err) {
                console.error("Error fetching next order number:", err);
            }
        }

        // 기존 공고 정보를 복사하되, 오더번호는 새로 생성
        setNoticeInfo({
            req_number: newReqNumber,
            work_date: reserve.work_date || '',
            work_time: reserve.work_time || '',
            address: reserve.address || '',
            address_sub: reserve.address_sub || '',
            info: reserve.info || '',
            option: reserve.option || '',
            working_kind: reserve.working_kind || '',
            amount: reserve.amount || '',
            memo: reserve.memo || '',
            admin_memo: reserve.admin_memo || ''
        });
        setSelectedProducts(parsedProducts);
        modalNotice.current.showModal();
    }

    const closeNoticeModal = () => {
        modalNotice.current.close();
    }

    const handleChange = async (e) => {
        const { name, value } = e.target;
        if (name === 'amount') {
            // Limit amount to prevent integer overflow (max 2 billion)
            if (value.length > 10 || Number(value) > 2000000000) return;
        }
        setNoticeInfo(prev => ({ ...prev, [name]: value }));

        // 작업일 변경 시 오더번호 자동 생성
        if (name === 'work_date' && value) {
            try {
                const res = await axios.get('/GenerateOrderNumber', {
                    params: { work_date: value }
                });
                if (res.data.success) {
                    setNoticeInfo(prev => ({ ...prev, req_number: res.data.message }));
                }
            } catch (err) {
                console.error("Error generating order number:", err);
            }
        }
    }

    // Address Handler
    const handleAddressComplete = (data) => {
        let fullAddress = data.address;
        let extraAddress = '';

        if (data.addressType === 'R') {
            if (data.bname !== '') {
                extraAddress += data.bname;
            }
            if (data.buildingName !== '') {
                extraAddress += (extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName);
            }
            fullAddress += (extraAddress !== '' ? ` (${extraAddress})` : '');
        }

        setNoticeInfo(prev => ({ ...prev, address: fullAddress }));
        setAddressModalOpen(false);
    };

    // Product List (Info) Handlers
    const [selectedProducts, setSelectedProducts] = useState([]);

    const handleAddInfo = (e) => {
        const selectedItem = e.target.value;
        if (!selectedItem) return;

        // Check if already selected
        if (!selectedProducts.find(p => p.name === selectedItem)) {
            setSelectedProducts(prev => [...prev, { name: selectedItem, count: 1 }]);
        }
    };

    const handleRemoveInfo = (nameToRemove) => {
        setSelectedProducts(prev => prev.filter(p => p.name !== nameToRemove));
    };

    const handleCountChange = (name, count) => {
        const newCount = parseInt(count, 10);
        if (newCount < 1) return;
        setSelectedProducts(prev => prev.map(p => p.name === name ? { ...p, count: newCount } : p));
    };

    const handleRegister = async () => {
        // Serialize selectedProducts to string
        const infoString = selectedProducts.map(p => `${p.name} ${p.count}대`).join(', ');

        const payload = {
            ...noticeInfo,
            info: infoString,
            staff_id: auth?.loginId || 'system'
        };

        if (!payload.req_number || !payload.address) {
            alert('오더번호와 주소는 필수입니다.');
            return;
        }

        try {
            const res = await axios.post('/NoticeList/Register', payload);
            if (res.data.success) {
                alert('공고가 성공적으로 등록되었습니다.');
                closeNoticeModal();
                getReservationTotal();
                getReserveCount();
            } else {
                alert('등록에 실패했습니다.');
            }
        } catch (error) {
            console.error('Registration error:', error);
            alert('오류가 발생했습니다.');
        }
    };

    useEffect(() => {
        getReservationTotal();
        getReserveCount();
    }, [page, statusFilter]);

    // 필터 선택 핸들러
    const handleSelect = (menu) => {
        setStatusFilter(menu);
        setView(false);
        setPage(1);
    };

    useEffect(() => {
        const getProductList = async () => {
            try {
                const res = await axios.get('/PriceInfo');
                if (res.data.success) {
                    setProductList(res.data.message);
                }
            } catch (err) {
                console.error("Error fetching product list:", err);
            }
        };
        getProductList();
    }, []);

    return (
        <div style={{ padding: '20px' }}>
            {/* 상태 필터 드롭다운 */}
            <div className="w90p" style={{ marginTop: '40px', margin: '0 auto', position: 'relative' }}>
                <TopBarContainer>
                    <FilterContainer>
                        <FilterButton onClick={() => setView(!view)}>
                            {statusFilter}
                            <span style={{ fontSize: '12px', color: '#999' }}>▼</span>
                        </FilterButton>
                        {view && (
                            <DropdownList>
                                {['전체', '대기', '공고', '매칭', '완료'].map((menu) => (
                                    <DropdownItem key={menu} onClick={() => handleSelect(menu)}>
                                        {menu}
                                    </DropdownItem>
                                ))}
                            </DropdownList>
                        )}
                    </FilterContainer>
                </TopBarContainer>
            </div>
            <div style={{ marginTop: '5px' }}>
                <CommonTable headerTitle={['No', '오더번호', '작업일자', '작업시간', '주소', '예약상품', '모집분야', '예상금액', '상태', '']}>
                    {
                        reserveList.map((reserve, index) => {
                            // 마감 여부 계산: 상태가 '공고'이고 작업일시가 현재보다 과거인 경우
                            const isExpired = reserve.status === '공고' && 
                                reserve.work_date && 
                                reserve.work_time &&
                                dayjs(`${reserve.work_date} ${reserve.work_time}`).isBefore(dayjs());
                            const displayStatus = isExpired ? '마감' : (reserve.status || '대기');

                            return (
                                <CommonTableRow key={index} idx={reserve.idx} kind="notice_list">
                                    <CommonTableColumn>{reserveCount - ((page - 1) * 10) - index}</CommonTableColumn>
                                    <CommonTableColumn>{reserve.req_number}</CommonTableColumn>
                                    <CommonTableColumn>{reserve.work_date}</CommonTableColumn>
                                    <CommonTableColumn>{reserve.work_time}</CommonTableColumn>
                                    <CommonTableColumn>
                                        {(() => {
                                            const fullAddr = (reserve.address || '') + (reserve.address_sub ? ' ' + reserve.address_sub : '');
                                            return fullAddr.length > 25 ? fullAddr.substring(0, 25) + '...' : fullAddr;
                                        })()}
                                    </CommonTableColumn>
                                    <CommonTableColumn>
                                        {(() => {
                                            const text = `${reserve.info} ${reserve.option ? `(${reserve.option})` : ''}`;
                                            return text.length > 20 ? text.substring(0, 20) + '...' : text;
                                        })()}
                                    </CommonTableColumn>
                                    <CommonTableColumn>{reserve.working_kind}</CommonTableColumn>
                                    <CommonTableColumn>{formatWon(reserve.amount)}</CommonTableColumn>
                                    <CommonTableColumn>
                                        <StatusBadge status={displayStatus}>
                                            {displayStatus}
                                        </StatusBadge>
                                    </CommonTableColumn>
                                    <CommonTableColumn>
                                        <div style={{ display: 'flex', gap: '6px' }}>
                                            {reserve.status === '대기' && (
                                                <>
                                                    <OutlineButton onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleNoticeClick(reserve.idx);
                                                    }}>공고</OutlineButton>
                                                    <CopyButton onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleCopyClick(reserve);
                                                    }}>📋</CopyButton>
                                                </>
                                            )}
                                            <DeleteButton onClick={(e) => {
                                                e.stopPropagation();
                                                handleDeleteClick(reserve.idx, reserve.status);
                                            }}>🗑️</DeleteButton>
                                        </div>
                                    </CommonTableColumn>
                                </CommonTableRow>
                            );
                        })
                    }
                </CommonTable>
            </div>

            <ButtonContainer>
                <PrimaryButton onClick={startNoticeModal}>공고등록</PrimaryButton>
            </ButtonContainer>

            <PaginationBox>
                <Pagination
                    activePage={page}
                    itemsCountPerPage={items}
                    totalItemsCount={reserveCount}
                    pageRangeDisplayed={10}
                    onChange={hadlePageChange}>
                </Pagination>
            </PaginationBox>

            <StyledDialog ref={modalNotice} style={{ width: '800px' }}>
                <DialogHeader>
                    <h3>공고 등록</h3>
                    <CloseButton onClick={closeNoticeModal}>&times;</CloseButton>
                </DialogHeader>
                <DialogContent>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                        <InputGroup>
                            <Label>오더번호</Label>
                            <StyledInput name="req_number" value={noticeInfo.req_number} readOnly style={{ backgroundColor: '#f5f5f5', cursor: 'default' }} />
                        </InputGroup>
                        <InputGroup>
                            <Label>예상금액</Label>
                            <StyledInput name="amount" type="number" value={noticeInfo.amount} onChange={handleChange} placeholder="숫자만 입력" />
                        </InputGroup>
                    </div>

                    <InputGroup>
                        <Label>주소</Label>
                        <div style={{ display: 'flex', gap: '10px' }}>
                            <StyledInput
                                name="address"
                                value={noticeInfo.address}
                                onChange={handleChange}
                                placeholder="클릭하여 주소 검색"
                                onClick={() => !noticeInfo.address && setAddressModalOpen(true)}
                            />
                            <OutlineButton onClick={() => setAddressModalOpen(true)} type="button" style={{ whiteSpace: 'nowrap' }}>주소 검색</OutlineButton>
                        </div>
                    </InputGroup>

                    <InputGroup>
                        <Label>상세주소</Label>
                        <StyledInput
                            name="address_sub"
                            value={noticeInfo.address_sub}
                            onChange={handleChange}
                            placeholder="상세주소 입력 (동/호수 등)"
                        />
                    </InputGroup>

                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                        <InputGroup>
                            <Label>작업일자</Label>
                            <StyledInput name="work_date" type="date" value={noticeInfo.work_date} onChange={handleChange} />
                        </InputGroup>
                        <InputGroup>
                            <Label>작업시간</Label>
                            <StyledInput name="work_time" type="time" value={noticeInfo.work_time} onChange={handleChange} />
                        </InputGroup>
                    </div>

                    <InputGroup>
                        <Label>예약상품 (정보)</Label>
                        <StyledSelect onChange={handleAddInfo} value="">
                            <option value="">상품 선택</option>
                            {productList.map((product, idx) => (
                                <option key={idx} value={product.kind}>{product.kind}</option>
                            ))}
                        </StyledSelect>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '8px' }}>
                            {selectedProducts.map((item, idx) => (
                                <Badge key={idx} style={{ display: 'flex', alignItems: 'center', gap: '5px', paddingRight: '6px' }}>
                                    {item.name}
                                    <input
                                        type="number"
                                        value={item.count}
                                        onChange={(e) => handleCountChange(item.name, e.target.value)}
                                        style={{ width: '40px', padding: '2px', border: '1px solid #ccc', borderRadius: '4px', textAlign: 'center' }}
                                        min="1"
                                    />
                                    <span
                                        onClick={() => handleRemoveInfo(item.name)}
                                        style={{ cursor: 'pointer', fontWeight: 'bold', fontSize: '1.1em', lineHeight: 0.8, marginLeft: '4px' }}
                                    >
                                        &times;
                                    </span>
                                </Badge>
                            ))}
                        </div>
                    </InputGroup>

                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
                        <InputGroup>
                            <Label>모집분야</Label>
                            <StyledSelect name="working_kind" value={noticeInfo.working_kind} onChange={handleChange}>
                                <option value="">선택하세요</option>
                                <option value="감리">감리</option>
                                <option value="분해조립">분해조립</option>
                                <option value="핀세척">핀세척</option>
                                <option value="부품세척">부품세척</option>
                                <option value="딜리버리">딜리버리</option>
                            </StyledSelect>
                        </InputGroup>
                    </div>

                    <InputGroup>
                        <Label>특이사항 (기사용)</Label>
                        <textarea
                            name="memo"
                            value={noticeInfo.memo}
                            onChange={handleChange}
                            placeholder="기사 앱에서 보이는 특이사항"
                            style={{
                                width: '100%',
                                padding: '0.6rem',
                                border: '1px solid #ddd',
                                borderRadius: '6px',
                                fontSize: '0.95rem',
                                boxSizing: 'border-box',
                                minHeight: '80px',
                                resize: 'vertical',
                                fontFamily: 'inherit'
                            }}
                        />
                    </InputGroup>
                    <InputGroup>
                        <Label>특이사항 (관리자 전용)</Label>
                        <textarea
                            name="admin_memo"
                            value={noticeInfo.admin_memo}
                            onChange={handleChange}
                            placeholder="관리자만 볼 수 있는 메모"
                            style={{
                                width: '100%',
                                padding: '0.6rem',
                                border: '1px solid #ffc107',
                                borderRadius: '6px',
                                fontSize: '0.95rem',
                                boxSizing: 'border-box',
                                minHeight: '80px',
                                resize: 'vertical',
                                fontFamily: 'inherit',
                                backgroundColor: '#fffef5'
                            }}
                        />
                    </InputGroup>
                </DialogContent>
                <DialogActions>
                    <OutlineButton onClick={closeNoticeModal}>취소</OutlineButton>
                    <PrimaryButton onClick={handleRegister}>등록</PrimaryButton>
                </DialogActions>
            </StyledDialog>

            {/* Address Search Modal */}
            <StyledDialog ref={addressModalRef} style={{ width: '500px' }}>
                <DialogHeader>
                    <h3>주소 검색</h3>
                    <CloseButton onClick={() => setAddressModalOpen(false)}>&times;</CloseButton>
                </DialogHeader>
                <DialogContent>
                    {addressModalOpen && <DaumPostcode onComplete={handleAddressComplete} />}
                </DialogContent>
            </StyledDialog>
        </div >
    );
}

// Styled Components copied from manager.js
const BaseButton = styled.button`
    padding: 8px 18px; 
    border-radius: 8px; 
    font-weight: 600;
    cursor: pointer; 
    transition: all 0.2s; 
    border: none; 
    font-size: 0.9rem;
`;

const PrimaryButton = styled(BaseButton)`
    background-color: #007bff;
    color: white;
    &:hover { background-color: #0056b3; }
`;

const OutlineButton = styled(BaseButton)`
    background-color: white; 
    border: 1px solid #ccc; 
    color: #555;
    &:hover { background-color: #f9f9f9; border-color: #bbb; }
`;

const DeleteButton = styled(BaseButton)`
    background-color: #fff5f5;
    border: 1px solid #f5c6cb;
    color: #dc3545;
    padding: 8px 12px;
    &:hover { background-color: #f8d7da; border-color: #dc3545; }
`;

const CopyButton = styled(BaseButton)`
    background-color: #f0f7ff;
    border: 1px solid #b3d4fc;
    color: #1976d2;
    padding: 8px 12px;
    &:hover { background-color: #e3f2fd; border-color: #1976d2; }
`;

const TopBarContainer = styled.div`
    display: flex;
    gap: 15px;
    align-items: flex-start;
    margin-bottom: 10px;
`;

const FilterContainer = styled.div`
    position: relative;
    width: 160px;
    margin-bottom: 10px;
`;

const FilterButton = styled.button`
    width: 100%;
    padding: 12px 16px;
    background: white;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    font-size: 15px;
    font-weight: 600;
    color: #333;
    transition: all 0.2s;
    box-shadow: 0 2px 5px rgba(0,0,0,0.02);
    
    &:hover {
        border-color: #006edc;
        color: #006edc;
        box-shadow: 0 2px 8px rgba(0,110,220,0.1);
    }
`;

const DropdownList = styled.ul`
    position: absolute;
    top: 105%;
    left: 0;
    width: 100%;
    background: white;
    border: 1px solid #f0f0f0;
    border-radius: 8px;
    box-shadow: 0 4px 15px rgba(0,0,0,0.1);
    padding: 6px;
    margin: 0;
    z-index: 100;
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 2px;
`;

const DropdownItem = styled.li`
    padding: 10px 12px;
    font-size: 14px;
    color: #555;
    cursor: pointer;
    border-radius: 6px;
    transition: all 0.2s;
    
    &:hover {
        background: #f5f9ff;
        color: #006edc;
        font-weight: 600;
    }
`;

const ButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 1rem;
    gap: 10px;
    width: 90%;
    margin-left: auto;
    margin-right: auto;
`;

const StyledDialog = styled.dialog`
    border: none; 
    border-radius: 16px; 
    padding: 0;
    box-shadow: 0 10px 40px rgba(0,0,0,0.25);
    &::backdrop { background: rgba(0, 0, 0, 0.6); }
`;

const DialogHeader = styled.div`
    padding: 16px 20px; 
    border-bottom: 1px solid #eee;
    display: flex; 
    justify-content: space-between; 
    align-items: center;
    h3 { margin: 0; font-size: 1.2rem; font-weight: 700; }
`;

const DialogContent = styled.div`
    padding: 24px; 
    background: #fff; 
    max-height: 80vh; 
    overflow-y: auto;
    display: flex; 
    flex-direction: column;
`;

const DialogActions = styled.div`
    padding: 16px 20px; 
    border-top: 1px solid #eee;
    display: flex; 
    justify-content: flex-end; 
    gap: 10px;
`;

const CloseButton = styled.button`
    background: none; 
    border: none; 
    font-size: 1.8rem; 
    cursor: pointer; 
    color: #999; 
    line-height: 1;
    &:hover { color: #333; }
`;

const InputGroup = styled.div`
    margin-bottom: 1rem;
`;

const Label = styled.label`
    display: block;
    margin-bottom: 0.5rem;
    color: #555;
    font-weight: 500;
    font-size: 0.9rem;
`;

const StyledInput = styled.input`
    width: 100%;
    padding: 0.6rem;
    border: 1px solid #ddd;
    border-radius: 6px;
    font-size: 0.95rem;
    box-sizing: border-box;

    &:focus {
        outline: none;
        border-color: #007bff;
        box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);
    }
`;

const StyledSelect = styled.select`
    width: 100%;
    padding: 0.6rem;
    border: 1px solid #ddd;
    border-radius: 6px;
    font-size: 0.95rem;
    box-sizing: border-box;
    background-color: white;

    &:focus {
        outline: none;
        border-color: #007bff;
        box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);
    }
`;

const Badge = styled.span`
    padding: 4px 10px; 
    border-radius: 20px; 
    font-size: 0.85rem; 
    font-weight: 600;
    background-color: #e3f2fd; 
    color: #1976d2;
`;

const StatusBadge = styled.span`
    padding: 5px 12px;
    border-radius: 20px;
    font-size: 0.85rem;
    font-weight: 600;
    background-color: ${props => {
        switch (props.status) {
            case '공고': return '#e3f2fd';  // 파란색 배경
            case '매칭': return '#f3e5f5';  // 보라색 배경
            case '완료': return '#e8f5e9';  // 녹색 배경
            case '마감': return '#f5f5f5';  // 회색 배경
            default: return '#fff3e0';       // 대기 - 주황색 배경
        }
    }};
    color: ${props => {
        switch (props.status) {
            case '공고': return '#1976d2';  // 파란색 글자
            case '매칭': return '#7b1fa2';  // 보라색 글자
            case '완료': return '#388e3c';  // 녹색 글자
            case '마감': return '#9e9e9e';  // 회색 글자
            default: return '#f57c00';       // 대기 - 주황색 글자
        }
    }};
`;

const PaginationBox = styled.div`
  .pagination { display: flex; justify-content: center; margin-top: 15px;}
  ul { list-style: none; padding: 0; }
  ul.pagination li {
    display: inline-block;
    width: 30px;
    height: 30px;
    border: 1px solid #e2e2e2;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem; 
  }
  ul.pagination li:first-child{ border-radius: 5px 0 0 5px; }
  ul.pagination li:last-child{ border-radius: 0 5px 5px 0; }
  ul.pagination li a { text-decoration: none; color: #337ab7; font-size: 1rem; }
  ul.pagination li.active a { color: white; }
  ul.pagination li.active { background-color: #337ab7; }
  ul.pagination li a:hover,
  ul.pagination li a.active { color: blue; }
`

export default NoticeList;
